module.exports = __webpack_public_path__ + "img/375_leuco_intro_img3.547d5bcf.png";